import { useState } from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { usePresentationMode } from '@/hooks/usePresentationMode'
import { useTheme } from '@/hooks/useTheme'
import { cn } from '@/lib/cn'

interface OutletContextType {
  presenting: boolean
}

export function AppShell() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const { presenting, toggle: togglePresenting } = usePresentationMode()
  const { isDark, toggle: toggleTheme } = useTheme()

  return (
    <div className="min-h-screen bg-[var(--surface-page)]">
      <Sidebar collapsed={sidebarCollapsed} />
      <Header
        presenting={presenting}
        onTogglePresenting={togglePresenting}
        isDark={isDark}
        onToggleTheme={toggleTheme}
        sidebarCollapsed={sidebarCollapsed}
        onToggleSidebar={() => setSidebarCollapsed((c) => !c)}
      />

      <main
        className={cn(
          'pt-14 min-h-screen transition-all duration-200',
          sidebarCollapsed ? 'pl-16' : 'pl-56',
        )}
      >
        <div className="p-6">
          <Outlet context={{ presenting } satisfies OutletContextType} />
        </div>
      </main>
    </div>
  )
}

export function usePresentation(): OutletContextType {
  return useOutletContext<OutletContextType>()
}
